import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/jsdom';
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/is-nan';
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
//import {BrowserRouter as Router} from 'react-router-dom';
import {HashRouter as Router} from 'react-router-dom';
//import './bdo.css';
import * as serviceWorker from './serviceWorker';
import App from './App';
ReactDOM.render( 
    <Router>
        <App/>      
    </Router>,
    document.getElementById('root'));   
serviceWorker.unregister();
//serviceWorker.register();
 